module.exports = __webpack_public_path__ + "static/media/csharp.299c3aa5.svg";